module.exports = __webpack_public_path__ + "img/active-layer9.b2204cf7.png";